import axios from "axios"
import { handleResponse } from "."
import { BASE_URL } from "../utils/constant"

// Define TypeScript interfaces
export interface SaveKeypairDto {
  identifier: string
  keypairBs58: string
}

export interface SaveKeypairFromIntArrayDto {
  identifier: string
  keypairIntArrayStr: string // e.g., "[1,2,3]"
}

export interface CreateKeypairDto {
  identifier: string
}

export interface CreatePublicKeypairResponse {
  publicKey: string
}

export interface PublicKeyResponse {
  publicKey: string
  balance?: string
}

export interface AllPublicKeysResponse {
  [identifier: string]: PublicKeyResponse
}

// Set the base URL for the API
const SERVICE_URL = `${BASE_URL}/keypairs` // Replace with your API URL

export class AccountService {
  // Wrapper methods
  public static createKeypair = async (identifier: string): Promise<CreatePublicKeypairResponse> => {
    return handleResponse<CreatePublicKeypairResponse>(
      axios.post<{ success: boolean; data: CreatePublicKeypairResponse }>(`${SERVICE_URL}/create`, { identifier }),
    )
  }

  public static saveKeypair = async (identifier: string, keypairBs58: string): Promise<void> => {
    const data: SaveKeypairDto = { identifier, keypairBs58 }
    await handleResponse<void>(axios.post<{ success: boolean; data: void }>(`${SERVICE_URL}/save`, data))
  }

  public static saveKeypairFromIntArray = async (identifier: string, keypairIntArrayStr: string): Promise<void> => {
    const data: SaveKeypairFromIntArrayDto = { identifier, keypairIntArrayStr }
    await handleResponse<void>(axios.post<{ success: boolean; data: void }>(`${SERVICE_URL}/saveArray`, data))
  }

  public static getPublicKey = async (identifier: string, includeBalance: boolean = false): Promise<PublicKeyResponse | null> => {
    return handleResponse<PublicKeyResponse>(
      axios.get<{ success: boolean; data: PublicKeyResponse }>(`${SERVICE_URL}/query`, {
        params: { identifier, includeBalance },
      }),
    )
  }

  public static getAllPublicKeys = async (includeBalance: boolean = true): Promise<AllPublicKeysResponse> => {
    return handleResponse<AllPublicKeysResponse>(
      axios.get<{ success: boolean; data: AllPublicKeysResponse }>(`${SERVICE_URL}/list`, {
        params: { includeBalance },
      }),
    )
  }

  public static removeKeypair = async (identifier: string): Promise<void> => {
    await handleResponse<void>(axios.delete<{ success: boolean; data: void }>(`${SERVICE_URL}/remove`, { data: { identifier } }))
  }
}
